// extracted by mini-css-extract-plugin
export default {"backdrop":"styles_backdrop__K4v5P","modal-container":"styles_modal-container__ioe-3","close":"styles_close__1TKBv","icon":"styles_icon__idqRl"};